<template>
  <div class="CadastroUsuarios">
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/termometria' }">Orçamentos Termometria</el-breadcrumb-item>
          <el-breadcrumb-item>Novo Orçamento Termometria</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-tabs type="card" style="margin-top:20px;">
      <el-tab-pane label="Termometria">
        <!-- ABA NEGÓCIO -->
        <el-row :gutter="10" type="flex" justify="center">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              :label-position="labelPosition"
            >
              <el-row :gutter="10" justify="center">
                <el-col :xs="24" :sm="24" :md="24" :lg="13" :xl="13">
                  <el-form-item label="Cliente" prop="cliente" class="listas">
                    <el-select
                      v-model="ruleForm.sge_cliente"
                      filterable
                      v-on:change="buscaCidadesClientes"
                      placeholder="Informe o Cliente"
                    >
                      <el-option
                        v-for="item in listClientes"
                        :key="item.CODIGO"
                        :label="item.RAZAO_SOCIAL"
                        :value="item.CODIGO"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="6" :lg="4" :xl="4">
                  <el-form-item label="Estado" prop="estado" class="listas">
                    <el-select
                      v-model="ruleForm.estado"
                      v-on:change="buscaCidades"
                      filterable
                      placeholder="Informe o Estado"
                    >
                      <el-option
                        v-for="item in listEstados"
                        :key="item.value"
                        :label="item.descricao"
                        :value="item.sigla"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="16" :md="18" :lg="7" :xl="7">
                  <el-form-item label="Cidade" prop="cidade" class="listas">
                    <el-select v-model="ruleForm.cidade" filterable placeholder="Informe a Cidade">
                      <el-option
                        v-for="item in listCidades"
                        :key="item.value"
                        :label="item.descricao"
                        :value="item.descricao"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" justify="center">
                <el-col :xs="24" :sm="8" :md="6" :lg="4" :xl="4">
                  <el-form-item label="Número do Negócio" prop="num_negocio">
                    <el-input v-model="ruleForm.num_negocio" type="number"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="6" :lg="4" :xl="4">
                  <el-form-item label="Versão" prop="versao">
                    <el-input v-model="ruleForm.versao" type="number"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" justify="center">
                <el-col :xs="24" :sm="8" :md="6" :lg="4" :xl="4">
                  <el-form-item label="Outros" prop="outros">
                    <el-input v-model="ruleForm.outros" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="6" :lg="4" :xl="4">
                  <el-form-item label="SubTotal" prop="subtotal">
                    <el-input v-model="ruleForm.subtotal" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="6" :lg="4" :xl="4">
                  <el-form-item label="IPI" prop="ipi">
                    <el-input v-model="ruleForm.ipi" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="6" :lg="4" :xl="4">
                  <el-form-item label="Total" prop="total">
                    <el-input v-model="ruleForm.total" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="grid-content"></div>
                </el-col>
              </el-row>
              <el-row>
                <br />
                <el-button type="primary" @click="orcamentoTermometriaGravar()" icon="el-icon-notebook-2" round>Gravar</el-button>
              </el-row>

            </el-form>
          </el-col>
        </el-row>
        <!-- FINAL ABA NEGOCIO -->
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>

import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  components: {
  },

  data() {
    return {
      mostra_msg_tecdig:false,
      listClientes: [],
      listEstados: [],
      listCidades: [],
      itens: [],
      permissao: {},
      rules: {
      },
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: true /* doesn't work with directive */,
      },
      percentual: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        suffix: "%",
        masked: true /* doesn't work with directive */,
      },
      loading: false,
      labelPosition: "right",
      ruleForm: {
        versao: 1,
        num_negocio: "",
        sge_cliente: "",
        cliente: "",
        sge_cidade: "",
        cidade: "",
        sge_estado: "",
        estado: "",
        outros: 0,
        subtotal: 0,
        ipi: 0,
        total: 0,
      },
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.editar_termometria) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    //LISTA DE CLIENTES - SGE
    axios
      .get(url + "/clientes", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (resp.status == "Token is Expired") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.listClientes = resp.data;
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message:
            "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      });

    //LISTA DE CIDADES ESTADOS - SGE
    axios
      .get(url + "/estadoscidades", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (resp.status == "Token is Expired") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.listEstados = resp.data;
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message:
            "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      });

  },

  methods: {
    buscaCidades() {
      let est = "";
      if (this.ruleForm.estado != "") {
        est = this.ruleForm.estado;
      }
      this.listCidades = this.listEstados[est]["cidades"];
    },
    buscaCidadesClientes() {
      let verifica;
      verifica = Number(this.ruleForm.sge_cliente);
      for (let i = 0; i < this.listClientes.length; i++) {
        if (this.listClientes[i].CODIGO == verifica) {
          this.ruleForm.cliente = this.listClientes[i].RAZAO_SOCIAL
          for (var prop in this.listEstados) {
            if (
              this.listEstados[prop].codigo == this.listClientes[i].ESTD_CODIGO
            ) {
              this.ruleForm.estado = this.listEstados[prop].sigla;
              this.ruleForm.sge_estado = this.listEstados[prop].codigo;

              this.listCidades = this.listEstados[prop].cidades;
              this.ruleForm.sge_cidade = this.listClientes[i].MUNI_CODIGO;
              for (var propCid in this.listEstados[prop].cidades) {
                if (
                  this.listEstados[prop].cidades[propCid].codigo ==
                  this.listClientes[i].MUNI_CODIGO
                ) {
                  this.ruleForm.cidade = this.listEstados[prop].cidades[
                    propCid
                  ].descricao;
                  break;
                }
              }
              break;
            }
          }
          break;
        }
      }
    },

    orcamentoTermometriaGravar(){
      let dados = {
        num_negocio: this.ruleForm.num_negocio,
        versao: this.ruleForm.versao, 
        sge_cliente: this.ruleForm.sge_cliente,
        cliente: this.ruleForm.cliente,
        sge_cidade: this.ruleForm.sge_cidade,
        cidade: this.ruleForm.cidade,
        sge_estado: this.ruleForm.sge_estado,
        estado: this.ruleForm.estado,
        outros: this.ruleForm.outros,
        subtotal: this.ruleForm.subtotal,
        ipi: this.ruleForm.ipi,
        total: this.ruleForm.total,
      }
      axios
      .post(url + "/termoregister", dados, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((resp) => {
        if (resp.status == "Token is Expired") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          //this.listEstados = resp.data;
        }
      })
      .catch((err) => {
        this.$notify({
          title: "Erro",
          message:
            "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
          type: "error",
        });
      });
      this.$router.push("/termometria");

    },

  },
};
</script>
<style>
</style>